import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import TextTableCell from 'components/common/table/TextTableCell';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import FlexBox from 'components/common/FlexBox';
import CheckboxTableCell from 'components/common/table/CheckboxTableCell';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_LEASING_EXPENSE_TYPES_WRITE } from 'constants/rightsCodes';
import ActionsTableCell from 'components/common/table/ActionsTableCell';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const LeasingExpenseTypeComponent = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const canWrite = usePermission(ADMIN_LEASING_EXPENSE_TYPES_WRITE);
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/leasingExpenseTypes/${data.expenseTypeId}`);
  }, [historyContext, data]);

  return (
    <TableRow hover key={data.expenseTypeId}>
      <TextTableCell content={data.expenseCode} />
      <TextTableCell content={data?.expenseName} />
      <TableCell>{data?.currencyValue}</TableCell>
      <TableCell>{data?.currencyCode}</TableCell>
      <TableCell>{data?.currencyPercent}</TableCell>
      <CheckboxTableCell checked={data.isActive} />
      <ActionsTableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton
            type={canWrite ? 'edit' : 'view'}
            variant='text'
            color='primary'
            size='small'
            tooltip={canWrite ? t('Edit') : t('View')}
            onClick={handleEdit}
            disabled={!canWrite}
          />
          <IconButton
            type='delete'
            variant='text'
            color='primary'
            size='small'
            tooltip={t('Delete')}
            onClick={() => onDelete(data.expenseTypeId)}
            disabled={!canWrite}
          />
        </FlexBox>
      </ActionsTableCell>
    </TableRow>
  );
};

LeasingExpenseTypeComponent.propTypes = {
  data: PropTypes.object,
  onDelete: PropTypes.func.isRequired
};

export default LeasingExpenseTypeComponent;
